// extracted by mini-css-extract-plugin
export var dividerLine = "_4s-0";
export var errorBackground = "_4s-1";